import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { toast } from "sonner";

export default function Login() {
  const { t } = useLang();
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { const u = await login(email, password); nav(params.get("redirect") || (u.role === "admin" ? "/admin/waitlist" : "/portal")); }
    catch (e) { toast.error(e.response?.data?.detail || t({ en: "Sign in failed", fr: "Échec de la connexion" })); }
    finally { setLoading(false); }
  };
  return (
    <div className="max-w-md mx-auto px-4 py-16 lg:py-24" data-testid="login-page">
      <div className="overline mb-4">{t({ en: "Sign in", fr: "Connexion" })}</div>
      <h1 className="font-serif text-4xl mb-8 tracking-tight" style={{ color: "var(--ink)" }}>{t({ en: "Welcome back.", fr: "Bon retour." })}</h1>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="overline mb-2 block">{t({ en: "Email", fr: "Courriel" })}</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full p-3 rounded-lg border" style={{ borderColor: "var(--border-medium)", background: "var(--surface)" }} data-testid="login-email" />
        </div>
        <div>
          <label className="overline mb-2 block">{t({ en: "Password", fr: "Mot de passe" })}</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full p-3 rounded-lg border" style={{ borderColor: "var(--border-medium)", background: "var(--surface)" }} data-testid="login-password" />
        </div>
        <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="btn-login">
          {loading ? t({ en: "Signing in…", fr: "Connexion…" }) : t({ en: "Sign in", fr: "Se connecter" })}
        </button>
      </form>
      <p className="mt-4 text-sm"><Link to="/forgot-password" className="link-underline" data-testid="login-forgot-password">{t({ en: "Forgot your password?", fr: "Mot de passe oublié?" })}</Link></p>
      <p className="mt-6 text-sm" style={{ color: "var(--ink-2)" }}>{t({ en: "New here?", fr: "Nouveau ici?" })} <Link to={`/register${params.get("redirect") ? `?redirect=${params.get("redirect")}` : ""}`} className="link-underline">{t({ en: "Create an account", fr: "Créer un compte" })}</Link></p>
    </div>
  );
}
